import Vue from 'vue'
import { isIE11 } from './check'
import store from '@/store'

export function makeObject(str) {
  if (!str) str = ''
  let units = str.split(';')
  let resObj = {}
  units.forEach(unit => {
    let t = unit.split('=')
    if (t.length !== 2) return
    resObj[t[0]] = t[1]
  })
  return resObj
}

export function makeString(obj) {
  if (!obj) obj = {}
  let keys = Object.keys(obj)
  let keyNValues = keys.map(key => {
    return `${key}=${obj[key] ? obj[key] : ''}`
  })
  return keyNValues.join(';')
}

export function makeKeyNValueArray(str) {
  if (!str) str = ''
  let units = str.split(';')
  let resObj = []
  units.forEach(unit => {
    let t = unit.split('=')
    if (t.length !== 2) return
    resObj.push({
      key: t[0],
      value: t[1]
    })
  })
  return resObj
}

export function makeKeyNValueString(arr) {
  if (!arr || !Array.isArray(arr)) arr = []
  let keyNValues = arr.map(kv => {
    return `${kv.key}=${kv.value}`
  })
  return keyNValues.join(';')
}

export function getPopupPositionLeft(popupWidth) {
  return (document.body.clientWidth - popupWidth) / 2
}

/**
 * Fullscreen 버튼 선택 시, content 영역을 확장한다.
 */
export function openFullscreen(target) {
  if (target.requestFullscreen) {
    target.requestFullscreen()
  } else if (target.mozRequestFullScreen) {
    /* Firefox */
    target.mozRequestFullScreen()
  } else if (target.webkitRequestFullscreen) {
    /* Chrome, Safari & Opera */
    target.webkitRequestFullscreen()
  } else if (target.msRequestFullscreen) {
    /* IE/Edge */
    target.msRequestFullscreen()
  }
}

/**
 * Script를 Lazy 로드 할 수 있게 Promise Pattern으로 구성
 */
export function scriptLoader(url, key) {
  return new Promise((resolve, reject) => {
    // 기존 동일한 호출된 자바스크립트가 있을 경우, 재 구동한다.
    const existing = document.querySelector('script#' + key)
    if (existing) existing.remove()
    const script = document.createElement('script')
    script.onload = () => {
      // 스크립트 구동이 완료되면, 해당 함수에서 resolve를 호출하여 사용하는 곳에서 호출 완료 시점을 알 수 있다.
      resolve()
    }
    script.onerror = e => {
      reject(e)
    }
    script.id = key
    // 비동기 지연 로딩
    script.async = true
    script.defer = true
    script.src = url
    document.head.appendChild(script)
  })
}

export function dispatchResize() {
  if (isIE11()) {
    var evt = document.createEvent('UIEvents')
    evt.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(evt)
  } else {
    window.dispatchEvent(new Event('resize'))
  }
}

export function printElement(elementRef) {
  let app = document.getElementById('app')
  const printContents = elementRef.innerHTML
  let printDiv = document.createElement('DIV')
  document.body.appendChild(printDiv)
  printDiv.innerHTML = printContents
  app.style.display = 'none'
  window.print()
  app.style.display = 'block'
  printDiv.style.display = 'none'
  printDiv.innerHTML = ''
}

// Framework에서  Page 단위로 사용되는 영역을 Print할 경우 사용
export function printPage() {
  // 페이지를 제외한 다른 부분 (해더, 푸터 등) 을 v-show를 활용하여 invisible하게 변경
  store.dispatch('SetPrinting', true)
  Vue.nextTick(() => {
    dispatchResize()
    setTimeout(() => {
      window.print()
      store.dispatch('SetPrinting', false)
    }, 100)
  })
}
